module.exports = __webpack_public_path__ + "media/bootstrap-icons/map-0da38b3f.svg";